import React from 'react';
import DatePicker from "../common/DatePicker";
import GenericInput from "../common/input/GenericInput";
import SSN from "../common/input/SSNInput";
import { connect } from "react-redux";
import * as types from "../../constants/actionTypes";
import Spinner from "../common/spinner";
import * as Tools from "../../helpers/Tools";
import AutoLinkErrorForHP from "../healthplan/AutoLinkErrorForHP";
import StatusBanner from '../common/StatusBanner';

class AALinkForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dateOfBirth: '',
            memberId: '',
            ssn: '',
            validDob: true,
            validMemberId: true,
            validSsn: true,
            validationError: "",
        };
        this.onLinkAccount = this.onLinkAccount.bind(this);
        this.setValidationMessage = this.setValidationMessage.bind(this);
    }

    setValidationMessage(sMessage) {
        const { validationError } = this.state;
        if (validationError !== sMessage) {
            this.setState({ validationError: sMessage });
        }
    }

    inputsChanged() {
        this.setState({ validationError: "" });
        this.props.clearLinkMessages();
    }

    digits(str, length) {
        return str.replace(/[^0-9]/g, '').length >= length;
    }

    isValidate(fromInput) {
        const { dateOfBirth, ssn, memberId } = this.state;
        let validDob, validMemberId, validSsn;
        validDob = this.digits(dateOfBirth, 8);
        validSsn = this.digits(ssn, 9);
        validMemberId = this.digits(memberId, 4);
        if (validSsn !== this.state.validSsn || validMemberId !== this.state.validMemberId || validDob !== this.state.validDob)
            this.setState({ validDob, validMemberId, validSsn });
        if (!fromInput) {
            if (!validDob) {
                return false;
            }
            if (!validSsn && !validMemberId) {
                this.setValidationMessage("Please complete Member ID or Social Security Number.");
                return false;
            }
        }
        return validDob && (validMemberId || validSsn);
    }
    onInputChange(field, value, isValid) {
        if (typeof isValid === 'undefined' || isValid) {
            this.setState({ [field]: value }, () => { this.inputsChanged(); this.isValidate(true); });
        }
        else {
            this.isValidate(true);
        }

    }

    onLinkAccount(e) {
        const { memberId, ssn, dateOfBirth } = this.state;
        if (!this.isValidate(false)) {
            this.setState({ showAsInvalid: true }); return;
        }
        this.props.linkAAAccount(Tools.dateStringFormat(dateOfBirth, "YYYY-MM-DD"), ssn.replace(/-/g, ""), memberId);
    }

    render() {
        const { memberId, dateOfBirth, ssn } = this.state;
        const { linkAAError, isAALLinking, linkAASuccess, countOfLinkAAError } = this.props;        

        return (<React.Fragment>
            {(!linkAASuccess && countOfLinkAAError === 3) ? <AutoLinkErrorForHP /> :
                !linkAASuccess ?
                    <div className="container-fluid body-content aa-link-form aa-link-mobile">
                        <div className="row">
                            <div className="col-12 maxWidth-content">
                                <div className="row">
                                    <div className="col-12 text-center">
                                        <img alt="aa-logo" className="aa-logo-modal" src="/images/aa_logo.svg" />
                                    </div>
                                    <div className="col-12">
                                        <p className="heading">Link your BSWQA-DFW ConnectedCare Account with MyBSWHealth</p>
                                    </div>
                                    <div className="col-12 aal-container page-form-sm">
                                        <div className="row aal-form-fields-container">
                                            <div className="col-12">
                                                <DatePicker dobId="dateOfBirth" required value={dateOfBirth} placeholder="Date of Birth"
                                                    inputErrorMsg={"Please enter a valid date of birth."} yearsBackward={140} maxDate={new Date()}
                                                    onChange={(value, isDobValid) => { console.log(isDobValid); this.onInputChange('dateOfBirth', !isDobValid ? '' : `${(value.getMonth() + 1).toString().padStart(2, "0")}/${value.getDate().toString().padStart(2, "0")}/${value.getFullYear()}`); }}
                                                    showAsInvalid={this.state.showAsInvalid && !this.state.validDob}
                                                />
                                            </div>
                                            <div className="col-12">
                                                <div className="hr-divider" />
                                            </div>
                                            <div className="col-12 form-group">
                                                <GenericInput name="memberId" placeholder="Member ID" value={memberId} onChange={(e, value) => { this.onInputChange('memberId', value); }}
                                                />
                                            </div>
                                            <div className="col-12 or-text">
                                                - OR -
                                        </div>
                                            <div className="col-12 form-group">
                                                <SSN name="SocialSecurityNumber" id="SocialSecurityNumber" placeholder="Social Security Number"
                                                    ref="SocialSecurityNumber" value={ssn} onChange={(e) => { this.onInputChange('ssn', e.target.value); }}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 text-center">
                                                {linkAAError && <div className="error-msg" dangerouslySetInnerHTML={linkAAError}/>}
                                                {isAALLinking ? <Spinner /> : null}
                                                {this.state.validationError && <div className="error-msg">{this.state.validationError}</div>}
                                            </div>
                                            <div className="col-12 form-group link-btn">
                                                <button className="btn btn-primary" onClick={this.onLinkAccount}>Link Account</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> :

                    <div className="container-fluid body-content DFWCC-status-container">
                        <div className="row">
                            <div className="col-12">
                                <StatusBanner
                                    bannerAlignment="left"
                                    bannerMsg="Thanks, you're all set!"
                                    subBannerMsg="We've successfully linked your account."
                                    scrollTop
                                />
                            </div>
                        </div>
                    </div>
            }
        </React.Fragment>);
    }
}
const mapStateToProps = (state) => {
    return {
        linkAAError: state.healthPlan.linkAAError,
        isAALLinking: state.healthPlan.isAALLinking,
        linkAASuccess: state.healthPlan.linkAASuccess,
        countOfLinkAAError: state.healthPlan.countOfLinkAAError
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        linkAAAccount: (dob, ssn, memberId) => dispatch({
            type: types.LINK_AA_ACCOUNT_START, payload: { dob: dob, ssn: ssn, memberId: memberId, isStandalone: true }
        }),
        clearLinkMessages: () => dispatch({
            type: types.LINK_AA_ACCOUNT_CLEAR_MESSAGE
        })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AALinkForm);